import React from 'react';

interface EmojiIconProps {
	src: string;
	width?: string | number;
	height?: string | number;
	alt?: string;
}

const EmojiIcon: React.FC<EmojiIconProps> = ({ src, width = 21, height = 21, alt = '' }) => (
	<img src={src} alt={alt} height={height} width={width} />
);

export default EmojiIcon;
